export const GET_BILL_ADJUSTMENTS = 'GET_BILL_ADJUSTMENTS';
export const SET_BILL_ADJUSTMENTS = 'SET_BILL_ADJUSTMENTS';
export const BILL_ADJUSTMENT_REQUEST = 'BILL_ADJUSTMENT_REQUEST';
export const RESET_BILL_ADJUSTMENTS = 'RESET_BILL_ADJUSTMENTS';
export const BILL_ADJUSTMENT_REQUEST_FAILURE = 'BILL_ADJUSTMENT_REQUEST_FAILURE';